export default {
  text: 'Sende mir Neuigkeiten und Angebote per E-Mail',
};
